import React from 'react';

import classNames from 'classnames';
import { useField } from 'formik';

import NumberFormat from 'CommonComponents/LocalisedNumberFormat';

export default function TextFormField({
    label,
    hideLabel,
    horizontalLayout,
    className,
    parentGridClass = 'tw-grid-cols-3',
    labelGridClass = 'tw-col-span-1',
    inputGridClass = 'tw-col-span-2',
    formatted = false,
    ...props
}) {
    const [field, meta, helpers] = useField(props);
    return horizontalLayout ? (
        <div className={parentGridClass + ' tw-grid tw-gap-4'}>
            <div className={labelGridClass}>
                <label htmlFor={props.name} className="text-input__label">
                    {label} {props.required && '*'}
                </label>
            </div>
            <div className={inputGridClass + ' tw-flex tw-flex-col tw-space-y-1.5'}>
                {formatted ? (
                    <NumberFormat
                        className={classNames(className, 'text-input', { 'tw-border tw-border-red-500': meta.touched && meta.error })}
                        {...field}
                        onValueChange={(val) => {
                            helpers.setValue(val.value);
                        }}
                        onChange={(e) => {}}
                        {...props}
                    />
                ) : (
                    <input
                        className={classNames(className, 'text-input', { 'tw-border tw-border-red-500': meta.touched && meta.error })}
                        {...field}
                        {...props}
                    />
                )}
                {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
            </div>
        </div>
    ) : (
        <div className="tw-flex tw-flex-col tw-space-y-1.5">
            {!hideLabel && (
                <label htmlFor={props.name} className="text-input__label">
                    {label} {props.required && '*'}
                </label>
            )}
            {formatted ? (
                <NumberFormat
                    className={classNames('text-input', meta.touched && meta.error ? 'tw-border tw-border-red-500' : 'tw-border-0', className)}
                    {...field}
                    onValueChange={(val) => {
                        helpers.setValue(val.value);
                    }}
                    onChange={(e) => {}}
                    {...props}
                />
            ) : (
                <input
                    className={classNames('text-input', meta.touched && meta.error ? 'tw-border tw-border-red-500' : 'tw-border-0', className)}
                    {...field}
                    {...props}
                />
            )}
            {meta.touched && meta.error ? <div className="tw-text-red-500 tw-text-sm">{meta.error}</div> : null}
        </div>
    );
}
